import React from "react";
import airflowVideo from "./media/prime1.mp4"; // replace with your actual video path
import "./PrecisionSection.css";
import { Link } from "react-router-dom";

function PrecisionSection() {
  return (
    <section className="precision-section">
      {/* Left content */}
      <div className="precision-content">
        <h1>
          Next-Gen Cleaning <br />  Precision
        </h1>
        <p>
          Our technology delivers a scientifically-proven clean — no
          harsh scraping, minimal to no discomfort. Clinically shown to remove
          2× more bacteria and whiten teeth with excellent result in one visit.
        </p>
        <Link to="/book">
  <button className="book-btn1">BOOK NOW</button>
</Link>
      </div>

      {/* Right video */}
      <div className="precision-video">
        <video
          src={airflowVideo}
          autoPlay
          loop
          muted
          playsInline
          className="video-element"
        />
      </div>
    </section>
  );
}

export default PrecisionSection;
